<template>
    <main class="p-2 md:p-5 w-full h-full max-h-main flex flex-col gap-2 items-start min-h-main">
        <div class="flex w-full max-h-full">
            <AppTabs
                class="text-sm flex-shrink-0 hidden md:block sticky"
                :values="tabs"
                labelProp="label"
                :selected-id="$route.name"
                :vertical="true"
                style="min-height: 100vh"
            />
            <div class="flex-grow max-h-full">
                <router-view></router-view>
            </div>
        </div>
    </main>
</template>

<script>
import AppTabs from '@/components/appTabs/AppTabs.vue';

export default {
    components: {
        AppTabs,
    },
    methods: {},
    data() {
        return {
            tabs: [
                {
                    id: 'transactions',
                    label: this.$t('transactions.title'),
                },
                {
                    id: 'subscriptions',
                    label: this.$t('contracts.title'),
                },
                {
                    id: 'organizations',
                    label: this.$t('organizations.organizations'),
                },
            ],
        };
    },
};
</script>
